<h2>Facilities <span *ngIf="this.hasSystemManagementPermission()">or Agencies</span></h2>
<hr />

<div class="row claim-header">
  <div class="col-md-12">
    <app-grid-wrapper #grid persistenceKey="providersList">
      <button class="btn btn-primary" (click)="addEntity()"><i class="fa fa-plus"></i> Add</button>
    </app-grid-wrapper>
  </div>
</div>
